import Box from '@mui/material/Box';

import Header from './components/Header';

import { Series } from './Hub/Series/Series';
import { StyledContainer } from './useStyles';

const EducationStudio = () => (
  <StyledContainer>
    <Header />
    <Box mt={{ md: 7, xs: 3 }}>
      <Series />
    </Box>
  </StyledContainer>
);

export default EducationStudio;
